import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "row d-flex mb-5" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-4" }),
  /*#__PURE__*/_createElementVNode("div", { class: "col-4" }, [
    /*#__PURE__*/_createElementVNode("h2", { class: "w-100 text-center pr-120" }, "PHIẾU NHẬP KHO")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "col-4" })
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h5", { class: "mb-0" }, "Ngày nhập kho:", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h5", { class: "mb-0" }, "Phiếu nhập kho số:", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { class: "align-items-center fs-6 fw-bolder" }, "Nhập tại kho:", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { class: "align-items-center fs-6 fw-bolder" }, "Họ, tên người giao:", -1)
const _hoisted_6 = { class: "row my-3" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, null, -1)
const _hoisted_8 = { class: "col-10 text-center" }
const _hoisted_9 = { class: "mx-3" }
const _hoisted_10 = { class: "mx-3" }
const _hoisted_11 = { class: "mx-3" }
const _hoisted_12 = { class: "mx-3" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, null, -1)
const _hoisted_14 = { class: "d-flex justify-content-center align-items-center mb-5" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h4", { class: "me-4 mb-0" }, "Tổng cộng:", -1)
const _hoisted_16 = { style: {"width":"20%"} }
const _hoisted_17 = { class: "d-flex justify-content-center align-items-center mb-5" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", { class: "me-4 mb-0" }, "Tổng số tiền (viết bằng chữ):", -1)
const _hoisted_19 = { style: {"width":"45%"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonCustom = _resolveComponent("ButtonCustom")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_ResponsiveLayout = _resolveComponent("ResponsiveLayout")!
  const _component_BienBanVatTuTable = _resolveComponent("BienBanVatTuTable")!
  const _component_DivCol = _resolveComponent("DivCol")!
  const _component_DivRow = _resolveComponent("DivRow")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_PageRowLayout = _resolveComponent("PageRowLayout")!

  return (_openBlock(), _createBlock(_component_PageRowLayout, null, {
    "page-row-header": _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.isCreating ? 'Tạo mới' : 'Chỉnh sửa'), 1)
    ]),
    "page-row-action-button": _withCtx(() => [
      _createVNode(_component_ButtonCustom, {
        "button-type": _ctx.ButtonsType.BACK,
        onClick: _ctx.goBack
      }, null, 8, ["button-type", "onClick"])
    ]),
    "page-row-content": _withCtx(() => [
      _createVNode(_component_el_form, {
        model: _ctx.form,
        rules: _ctx.rules,
        ref: "formRef",
        onSubmit: _withModifiers(() => {}, ["prevent"])
      }, {
        default: _withCtx(() => [
          _hoisted_1,
          _createVNode(_component_ResponsiveLayout, null, {
            "col-1": _withCtx(() => [
              _hoisted_2
            ]),
            "col-2": _withCtx(() => [
              _createVNode(_component_el_form_item, {
                class: "pt-3",
                prop: "ngayNhapKho"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_date_picker, {
                    modelValue: _ctx.form.ngayNhapKho,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.ngayNhapKho) = $event)),
                    class: "w-100",
                    placeholder: "Chọn ngày",
                    name: "ngayNhapKho",
                    format: "DD/MM/YYYY"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            "col-3": _withCtx(() => [
              _hoisted_3
            ]),
            "col-4": _withCtx(() => [
              _createVNode(_component_el_form_item, { class: "pt-3" }, {
                default: _withCtx(() => [
                  (_ctx.phieuNhapData)
                    ? (_openBlock(), _createBlock(_component_el_input, {
                        key: 0,
                        modelValue: _ctx.phieuNhapData.so_phieu,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.phieuNhapData.so_phieu) = $event)),
                        readonly: "",
                        disabled: "",
                        name: "soPhieu",
                        onFocus: _cache[2] || (_cache[2] = ($event: any) => ($event.target.select()))
                      }, null, 8, ["modelValue"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ResponsiveLayout, null, {
            "col-1": _withCtx(() => [
              _hoisted_4
            ]),
            "col-2": _withCtx(() => [
              (_ctx.phieuNhapData)
                ? (_openBlock(), _createBlock(_component_el_input, {
                    key: 0,
                    modelValue: _ctx.phieuNhapData.kho.ten_kho,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.phieuNhapData.kho.ten_kho) = $event)),
                    disabled: ""
                  }, null, 8, ["modelValue"]))
                : _createCommentVNode("", true)
            ]),
            "col-3": _withCtx(() => [
              _hoisted_5
            ]),
            "col-4": _withCtx(() => [
              _createVNode(_component_el_form_item, {
                prop: "nguoiGiao",
                class: "mb-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.form.nguoiGiao,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.nguoiGiao) = $event)),
                    placeholder: "Mời nhập tên người giao",
                    name: "nguoiGiao",
                    onFocus: _cache[5] || (_cache[5] = ($event: any) => ($event.target.select()))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _createTextVNode(" Theo hợp đồng số "),
              _createElementVNode("i", _hoisted_9, _toDisplayString(_ctx.hopDong?.so_hop_dong), 1),
              _createTextVNode(" ngày "),
              _createElementVNode("i", _hoisted_10, _toDisplayString(_ctx.moment(_ctx.hopDong?.ngay_ky).format('DD/MM/YYYY')), 1),
              _createTextVNode(" và hóa đơn số "),
              _createElementVNode("span", _hoisted_11, [
                _createVNode(_component_el_form_item, {
                  prop: "soHoaDon",
                  class: "d-inline-block"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.form.soHoaDon,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.soHoaDon) = $event)),
                      placeholder: "Nhập số hóa đơn",
                      name: "soHoaDon",
                      onFocus: _cache[7] || (_cache[7] = ($event: any) => ($event.target.select()))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _createTextVNode(" ngày "),
              _createElementVNode("span", _hoisted_12, [
                _createVNode(_component_el_form_item, {
                  prop: "ngayLamHoaDon",
                  class: "d-inline-block"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: _ctx.form.ngayLamHoaDon,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.ngayLamHoaDon) = $event)),
                      placeholder: "Nhập số hóa đơn",
                      name: "ngayLamHoaDon",
                      format: "DD/MM/YYYY",
                      onFocus: _cache[9] || (_cache[9] = ($event: any) => ($event.target.select()))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _hoisted_13
          ]),
          (_ctx.phieuNhapData)
            ? (_openBlock(), _createBlock(_component_BienBanVatTuTable, {
                key: 0,
                items: _ctx.phieuNhapData.vat_tu_nhap_kho
              }, null, 8, ["items"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_el_input, {
                value: _ctx.formatCurrencyAndQuantity(_ctx.totalPriceInNumber, false),
                disabled: ""
              }, null, 8, ["value"])
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createElementVNode("div", _hoisted_19, [
              _createVNode(_component_el_input, {
                modelValue: _ctx.totalPriceInText,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.totalPriceInText) = $event)),
                disabled: ""
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createVNode(_component_DivRow, { "additional-class": "mb-5" }, {
            default: _withCtx(() => [
              _createVNode(_component_DivCol, { cols: 10 }),
              _createVNode(_component_DivCol, { cols: 1 }, {
                default: _withCtx(() => [
                  _createVNode(_component_ButtonCustom, {
                    "button-type": _ctx.ButtonsType.SAVE,
                    "color-type": _ctx.ButtonTypeColors.SUCCESS,
                    onClick: _ctx.onSubmit
                  }, null, 8, ["button-type", "color-type", "onClick"])
                ]),
                _: 1
              }),
              _createVNode(_component_DivCol, { cols: 1 })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _: 1
  }))
}